<!-- TEMPLATE -->
<template>
  <div :class='partnerDetailsClass'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-item
          v-if="canChangePartnerStatus()"
          :icon='editIcon'
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="statusChange"
      >
        Status wijzigen
      </dean-section-title-item>
      <dean-section-title-item
          v-if="canSavePartner()"
          :icon='saveIcon'
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="processPartner"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <dean-section-divider>Algemeen</dean-section-divider>
        <dean-form-row id="generic.kvkNumber" v-model="partnerData.kvkNumber"
                       @input="partnerData.kvkNumber.length === 8 && kvkDetails()"
                       :disabled="! canSavePartner()"
                       :required-field="true" :warning="$v.partner.kvkNumber.$error" label="KvK-nummer"></dean-form-row>
        <dean-form-row id="generic.name" v-model="partnerData.name" label="Naam"
                       :required-field="true" :warning="$v.partner.name.$error"
                       :disabled="disableFields || ! canSavePartner()"
                       @focus="$v.partner.name.$touch()"></dean-form-row>
        <dean-select-form-row placeholder="Kies een bedrijfsvorm" label='Bedrijfsvorm partner'
                              :options='personTypes'
                              :disabled="disableFields || ! canSavePartner()"
                              :required-field="true" :warning="$v.partner.type.$error"
                              @focus="$v.partner.type.$touch()"
                              :value='currentType' id="bedrijfsvorm"
                              @input='personTypeFieldChanged'></dean-select-form-row>
        <dean-form-row id="generic.email" v-model="partnerData.email" label="E-mail"
                       :required-field="true"
                       :warning="$v.partner.email.$error"
                       :disabled="disableFields || ! canSavePartner()"
                       @focus="$v.partner.email.$touch()"></dean-form-row>
        <dean-form-row id="generic.phoneNumber" v-model="partnerData.phoneNumber"
                       :disabled="disableFields || ! canSavePartner()"
                       label="Telefoonnummer"></dean-form-row>
        <dean-form-row id="generic.faxNumber" v-model="partnerData.faxNumber"
                       :disabled="disableFields || ! canSavePartner()"
                       label="Faxnummer"></dean-form-row>
        <dean-form-row id="generic.vatNumber" v-model="partnerData.vatNumber"
                       :required-field="true"
                       :warning="$v.partner.vatNumber.$error"
                       :disabled="disableFields || ! canSavePartner()"
                       label="BTW-nummer"></dean-form-row>
        <dean-form-row id="generic.website" v-model="partnerData.website"
                       :disabled="disableFields || ! canSavePartner()"
                       label="Website"></dean-form-row>
      </div>
      <div class="column" slot="right">
        <dean-section-divider>Adresgegevens</dean-section-divider>
        <dean-form-row id="mainAddress.street" v-model="partnerData.address.street" label="Straat"
                       :required-field="true" :warning="$v.partner.address.street.$error"
                       :disabled="disableFields || ! canSavePartner()"
                       @focus="$v.partner.address.street.$touch()"></dean-form-row>
        <dean-form-row id="mainAddress.houseNumber" v-model="partnerData.address.houseNumber"
                       label="Huisnummer"
                       :disabled="disableFields || ! canSavePartner()"
                       :required-field="true" :warning="$v.partner.address.houseNumber.$error"
                       @focus="$v.partner.address.houseNumber.$touch()"></dean-form-row>
        <dean-form-row id="mainAddress.houseNumberExtension" v-model="partnerData.address.houseNumberExtension"
                       label="Toevoeging huisnummer" :warning="$v.partner.address.houseNumberExtension.$error"
                       :disabled="disableFields || ! canSavePartner()"
                       @focus="$v.partner.address.houseNumber.$touch()"></dean-form-row>
        <dean-form-row id="mainAddress.postalCode" v-model="partnerData.address.postalCode" label="Postcode"
                       :required-field="true" :warning="$v.partner.address.postalCode.$error"
                       :disabled="disableFields || ! canSavePartner()"
                       @focus="$v.partner.address.postalCode.$touch()"></dean-form-row>
        <dean-form-row id="mainAddress.city" v-model="partnerData.address.city" label="Plaats"
                       :required-field="true" :warning="$v.partner.address.city.$error"
                       :disabled="disableFields || ! canSavePartner()"
                       @focus="$v.partner.address.city.$touch()"></dean-form-row>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {Component} from 'vue-property-decorator';
  import {deanDialogBus} from '@/main';
  import axios from 'axios';

  import {
    deanAlertDialog,
    deanInputField,
    deanSearchField,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    returnIcon,
    saveIcon,
    lockIcon,
    lockOpenIcon,
    trashIcon,
    editIcon,
    warningIcon,
  } from '@deanone/dean-components';
  import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanSectionTitleRemoveRestore from '@/components/deanComponents/deanSectionTitleRemoveRestore.vue';
  import {validationMixin} from 'vuelidate';
  import {required, email} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotificationFromData, validationMessage} from '@/mixins/validations';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';


  @Component({
    components: {
      DeanSelectFormRow,
      deanAlertDialog,
      deanInputField,
      DeanTwoColumnLayout,
      deanInputSelect,
      DeanFormRow,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      deanSectionTitleRemoveRestore,
      editIcon,
      warningIcon,
    },
    mixins: [validationMixin],
  })
  export default class PartnersDetails extends mixins(sideMenuPartnerMixin) {
    public partner: {
      id: any,
      code: any,
      name: any,
      type: any,
      typeName: any,
      email: any,
      phoneNumber: any,
      faxNumber: any,
      kvkNumber: any,
      vatNumber: any,
      website: any,
      address: {
        street: any,
        houseNumber: any,
        houseNumberExtension: any,
        postalCode: any,
        city: any,
      },
      deleted: boolean,
      suspended: boolean,
      status: any,
    } = {
      id: null,
      code: null,
      name: null,
      type: null,
      typeName: null,
      email: null,
      phoneNumber: null,
      faxNumber: null,
      kvkNumber: null,
      vatNumber: null,
      website: null,
      address: {
        street: null,
        houseNumber: null,
        houseNumberExtension: null,
        postalCode: null,
        city: null,
      },
      deleted: false,
      suspended: false,
      status: null,
    };
    public personTypes: any[] = [];

    public returnIcon: object = returnIcon;
    public saveIcon: object = saveIcon;
    public editIcon: object = editIcon;
    public trashIcon: object = trashIcon;
    public showSomething: boolean = false;
    public timeout?: number;
    public disableFields: boolean = true;

    // COMPUTED
    @Validations()
    get validations() {
      return {
        partner: {
          kvkNumber: {required},
          vatNumber: {required},
          name: {required},
          type: {required},
          email: {required, email},
          address: {
            street: {required},
            houseNumber: {required},
            houseNumberExtension: {},
            postalCode: {required},
            city: {required},
          },
        },
      };
    }

    get partnerDetailsClass() {
      let value = 'partner-add';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get partnerData() {
      return this.partner;
    }

    get currentType() {
      const personTypes = this.personTypes;
      const currentType = this.partnerData.type;
      if (currentType !== null) {
        const foundKey: any = Object.keys(personTypes).find((key: any) => personTypes[key].value === currentType);
        return foundKey !== null ? personTypes[foundKey] : null;
      }
      return null;
    }

    get headerTitle(): string {
      return (this.$route.params.pid !== undefined) ? 'Partner wijzigen' : 'Partner toevoegen';
    }

    public personTypeFieldChanged(field: any) {
      this.partner.type = field.value;
    }

    public kvkDetails() {
      const url: string = '/-/trade/api/kvk.info';

      axios
        .post(url, { kvkNumber: this.partner.kvkNumber })
        .then((response: any) => {
          const address = this.partner.address;

          this.partner.name = (! this.partner.name) ? response.data.businessName : this.partner.name;
          this.partner.website = (! this.partner.website) ? response.data.website : this.partner.website;
          address.street = (! address.street) ? response.data.street : address.street;
          address.houseNumber = (! address.houseNumber) ? response.data.houseNumber : address.houseNumber;
          address.houseNumberExtension =
            (! address.houseNumberExtension) ? response.data.houseNumberExtension : address.houseNumberExtension;
          address.postalCode = (! address.postalCode) ? response.data.postalCode : address.postalCode;
          address.city = (! address.city ) ? response.data.city : address.city;

          this.disableFields = false;
        },
        (error: any) => {
          this.$toast({
            text: 'KVK-nummer is ongeldig.',
            title: 'Error',
            theme: 'danger',
          });
        },
      );
    }

    public partnerDetails(): Promise<boolean> {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('setLoadOverlay', true);
        const data = {id: this.$route.params.pid};
        this.$store.dispatch('requestPartner', data)
          .then((response) => {
              const partner = response.data;

              this.partner = partner;

              this.$store.dispatch('setLoadOverlay', false);
            },
            (error) => {
              this.$store.dispatch('setLoadOverlay', false);
            });
      });
    }

    public initPersonTypes() {
      const url = '/-/trade/api/person.types.list';

      axios.post(url).then(
        (response) => {
          this.personTypes = [];
          for (const personType of response.data) {
            this.personTypes.push({
              value: personType.id,
              label: personType.name,
            });
          }
        },
        (error) => {
          // tslint:disable-next-line:no-console
          console.error(error);
        },
      );
    }

    public created() {
      if (this.$route.params.pid !== undefined) {
        this.buildSideMenuPartner();
        this.partnerDetails();
        this.disableFields = false;
      } else {
        this.$toast({
          text: 'Voer het KVK-nummer in om de rest van de velden automatisch in te vullen.',
          title: 'Info',
          theme: 'info',
        });
      }

      this.initPersonTypes();
    }

    public sectionRoute(name: string) {
      this.$router.push({name});
    }

    public statusChange() {
      deanDialogBus.$emit('open', 'PartnerStatusChangeDialog', {
        id: this.$route.params.pid,
        status: this.partner.status,
      });
    }

    public processPartner() {
      this.$v.$touch();

      if (! this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);
        const data = {
          id: this.$route.params.pid,
          data: this.partnerData,
        };
        this.$store.dispatch('processPartner', data).then(
          (response) => {
            if (data.id) {
              this.partner = response.data.data;
            } else {
              this.$router.push({
                name: 'partners.agreements.add',
                params: {
                  pid: response.data.data.id,
                },
              });
            }

            this.$toast({
              text: 'Partner opgeslagen',
              title: 'Succesvol opgeslagen',
              theme: 'success',
            });

            this.$store.dispatch('setLoadOverlay', false);
          },
          (error) => {
            if (
              error.response.data.errors
              && error.response.data.errors[0].code === 'ERR_PARTNER_KVK_NUMBER_EXISTS'
            ) {
              this.$toast({
                text: 'Partner met opgegeven KVK-nummer bestaat al',
                title: 'Fout',
                theme: 'danger',
                icon: warningIcon,
              });
            } else {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            }
            this.$store.dispatch('setLoadOverlay', false);
          },
        );
      } else {
        // temporary solution. we should build functionality for displaying validation error to end user
        if (this.partnerData.address &&
          this.partnerData.address.postalCode &&
          this.$v.partner &&
          this.$v.partner.address &&
          this.$v.partner.address.postalCode &&
          this.$v.partner.address.postalCode.$error
        ) {
          this.$toast(validationMessage('Ongeldige postcode!'));
        }

        this.$toast(createNotificationFromData(this.$v.partner));
      }
    }

    public canSavePartner(): boolean {
      if (
          this.partnerData?.id
          && this.$store.getters.getUser.privileges.includes('update-partner')
      ) {
        return true;
      }

      if (
          this.partnerData?.id === null
          && this.$store.getters.getUser.privileges.includes('create-partner')
      ) {
        return true;
      }

      return false;
    }

    public canChangePartnerStatus(): boolean {
      if (
          this.$router.currentRoute.name === 'partners.edit'
          && this.$store.getters.getUser.privileges.includes('change-status-partner')
      ) {
        return true;
      }

      return false;
    }

    public mounted() {
      deanDialogBus.$on('partnerStatusChange', () => {
        this.partnerDetails();
      });
    }

    public destroyed() {
      deanDialogBus.$off('personDelete');
      deanDialogBus.$off('personBlock');
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>
